/**
 * 统计的图层基类
 * Created by yangxinxin on 2016/12/14.
 */
'use strict';
/**
 * 政区统计基类
 * @module StatsticsLayer
 */
define([
    './BaseLayer',
    '../utils/CommonUtil',
    '../g2'
],function(
    BaseLayer,
    CommonUtil,
    g2
){
    /**
     * 构造方法
     * @constructor
     * @classdesc 统计图层基类
     * @augments G.lys.BaseLayer
     * @alias G.lys.StatsticsLayer
     * @param {Object} options - 必填，构造参数；
     * @param {G.Map/g2.carto.Map} options.map -必填，地图对象
     * @param {Object} options.symbolConfig - 可选，多种符号集合；
     * @param {String} options.layerId - 可选，图层id，默认为随机字符串
     * @param {Number} options.spatialReference - 可选，图层坐标系，默认地图坐标系
     * @param {Number} options.dataSpatialReference - 可选，叠加数据的坐标系，默认地图坐标系
     * @param {String} options.geometryField - 可选，空间属性名，默认为空，如果有值，则几何使用数据记录中对应的坐标信息；
     * @param {String} options.xField - 可选，数据记录中x坐标字段名，默认为LONGITUDE
     * @param {String} options.yField - 可选，数据记录中y坐标字段名，默认为LATITUDE
     * @param {Function} options.symbolUpdateCallback - 可选，地图显示的符号更新时的回调，
     * @param {Object} options.callbackContext - 可选，回调的上下文
     * @returns {Class} - 实例化的对象
     */
    var layer=BaseLayer.extend({
        options: {
            geometryField:'',
            xField:"LONGITUDE",//经度字段名
            yField:"LATITUDE",//纬度字段名
            showZero:false,//如果统计数都为零是否显示
            symbolConfigUrl:"" //样式配置文件路径
        },
        initialize: function (options) {
            BaseLayer.prototype.initialize.call(this,options);
            //符号配置
            if(CommonUtil.isObject(this.options.symbolConfig)){
                this.symbolConfig=jQuery(true,{},this.options.symbolConfig);
                delete this.options.symbolConfig;
            }
            //当前的符号
            this.currentSymbols=[];
            /****存储统计的数据*/
            this.statisticsData=null;
            //
            this._visible=true;
        },
        /**
         * 添加监听
         * @private
         */
        _addListeners:function(){
        },
        /**
         * 移除监听
         * @private
         */
        _removeListeners:function(){
            //
        },
        /**
         * 更新统计的数据
         * @method
         * @memberOf G.lys.StatsticsLayer.prototype
         * @param {Object} options - 必填，更新的参数
         * @param {Object} options.statisticsData - 必填，统计的数据
         * @param {Object/String} options.symbol - 必填，如果传递对象，则传递符号样式；
         * 如果传递字符串，则为初始化时配置的符号集里的key值；
         * @param {String} options.key - 可选，统计的资源标识
         * @param {String} options.title - 可选， 统计的资源名称
         */
        updateStatistics:function(options){},
        /**
         * 显示隐藏
         * @method
         * @memberOf G.lys.StatsticsLayer.prototype
         * @param {Boolean} visible - 必填
         */
        setVisible:function(visible){
        },
        /**
         * 获取图层显隐
         * @method
         * @memberOf G.lys.StatsticsLayer.prototype
         * @returns {Boolean}
         */
        getVisible:function(){
            return this._visible;
        },
        /**
         * 清除图层
         * @method
         * @memberOf G.lys.StatsticsLayer.prototype
         */
        clear:function(){
            this.statisticsData=null;
        },
        _updateLayer:function(config){},
        /**
         * 获取图层
         * @method
         * @memberOf G.lys.StatsticsLayer.prototype
         */
        getLayer:function(){},
        /**
         * @method
         * @param dest
         * @param src
         * @private
         */
        _mergeStatisticsData:function(dest,src){
            for(var key0 in src){
                var srcObj=src[key0],destObj=dest[key0];
                if(!destObj){
                    dest[key0]=srcObj;
                    continue;
                }
                jQuery.extend(true,destObj,srcObj);
            }
        },
        /**
         * 符号改变时调用的方法
         * @method
         * @private
         */
        _onSymbolsUpdated:function(){ },
        /***
         *
         * @private
         */
        _onElementChanged:function(){
            var array=this.getElements(),
                geometryArr=[];
            if(array&&array.length>0){
                for(var i=0,len=array.length;i<len;i++){
                    var ele=array[i];
                    if(ele&&ele.geometry){
                        geometryArr.push(ele.geometry);
                    }
                }
                var envelope=G.utils.GeometryUtil.getGeometryEnvlop(geometryArr);
                this._currentExtent=this._envelopeFromGeom(envelope);
            }else{
                this._currentExtent=[NaN,NaN,NaN,NaN];
            }
        },
        /**
         * 销毁
         * @method
         * @memberOf G.lys.StatsticsLayer.prototype
         */
        destroy:function(){
            this.clear();
            this._removeListeners();
            if(this.statisticsDataType){
                for(var key in this.statisticsDataType){
                    delete this.statisticsDataType[key];
                }
                this.statisticsDataType=null;
            }
            if(this.statisticsData){
                for(var key in this.statisticsData){
                    delete this.statisticsData[key];
                }
                this.statisticsData=null;
            }
            for(var key in this.options){
                delete this.options[key];
            }
            for(var key in this){
                delete this[key];
            }
            //
            BaseLayer.prototype.destroy.call(this);
        }

    });
    return layer;
});
